module.exports = __webpack_public_path__ + "static/media/Mountains.3c2ad2d0.jpg";